import { css } from '@emotion/react'
import { Spacing } from '@opallabs/gem'
import { sidebarStyles } from '../../Editor'

export const { container, label, field } = sidebarStyles

export const buttonOverrides = css({
  blockSize: Spacing.S * 2,
  marginInlineStart: Spacing.S,
  paddingInline: 0,
  '&:hover:enabled:before': { backgroundColor: 'transparent' },
})
